import { render, staticRenderFns } from "./ContactPropertySelectorInline.vue?vue&type=template&id=dec22c14"
import script from "./ContactPropertySelectorInline.vue?vue&type=script&lang=js"
export * from "./ContactPropertySelectorInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports